import Vue from 'vue'
// import messages from './lang'
import VueI18n from 'vue-i18n'
import store from "./store";

Vue.use(VueI18n)

let i18n
let messages;
// Fetch translations from the server
async function loadTranslations() {
    try {
        // console.log('translate------------------------')
        
        messages = store.state.languages;
        // console.log('messsages------------------------',messages)
        i18n = new VueI18n({
            locale: 'en',
            fallbackLocale: 'en',
            messages,
        })
        document.documentElement.lang = i18n.locale
    } catch (error) {
        console.error('Error loading translations:', error)
    }
}


document.documentElement.lang = localStorage.getItem('language') || 'en'
Vue.directive('custom-validation', {
    bind(el, binding) {
        el.addEventListener('invalid', () => {
            el.setCustomValidity(binding.value)
        })

        el.addEventListener('input', () => {
            el.setCustomValidity('')
            el.title = ''
        })
    },
})
Vue.prototype.$translate = function (key) {
    return i18n.t(key)
}
Vue.prototype.$cancelLabel = function () {
    return i18n.t('cancel')
}
Vue.prototype.$createLabel = function () {
    return i18n.t('create')
}
Vue.prototype.$viewLabel = function () {
    return i18n.t('view')
}
Vue.prototype.$updateLabel = function () {
    return i18n.t('update')
}
Vue.prototype.$deleteLabel = function () {
    return i18n.t('delete')
}
Vue.prototype.$backLabel = function () {
    return i18n.t('back')
}
Vue.prototype.$addLabel = function () {
    return i18n.t('add')
}
Vue.prototype.$nameLabel = function () {
    return i18n.t('name')
}
Vue.prototype.$textRequired = function () {
    return i18n.t('text_field_required')
}
Vue.prototype.$emailRequired = function () {
    return i18n.t('email_field_required')
}
Vue.prototype.$selectRequired = function () {
    return i18n.t('select_required')
}

export { i18n, loadTranslations }